import { render } from "./AppAudio.vue?vue&type=template&id=0601a21c&scoped=true"
import script from "./AppAudio.vue?vue&type=script&lang=js"
export * from "./AppAudio.vue?vue&type=script&lang=js"

import "@/Common/Styles/appAudio.scss?vue&type=style&index=0&id=0601a21c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0601a21c"]])

export default __exports__